import { findAreaList } from '@/service/api';
import AREA_TYPE, { IAreaItem, IAreaState } from "@/typings/area";
import { Module } from "vuex";
import { IGlobalState } from "..";
import * as Types from '../action-types';

const state: IAreaState = {
    provinceId: '',
    provinceName: '',
    cityId: '',
    cityName: '',
    districtId: '',
    districtName: '',
    provinces: [],
    citys: [],
    districts: []
};

const area: Module<IAreaState, IGlobalState> = {
    namespaced: true,
    state,
    mutations: {
        [Types.SET_AREA_PROVINCE_LIST](state, payload: IAreaItem[]) {
            state.provinces = payload;
        },
        [Types.SET_AREA_CITY_LIST](state, payload: IAreaItem[]) {
            state.citys = payload;
        },
        [Types.SET_AREA_DISTRICT_LIST](state, payload: IAreaItem[]) {
            state.districts = payload;
        },
        [Types.SET_AREA_CUR_PROVINCE](state, payload: IAreaItem) {
            state.provinceId = payload.id;
            state.provinceName = payload.areaName;
        },
        [Types.SET_AREA_CUR_CITY](state, payload: IAreaItem) {
            state.cityId = payload.id;
            state.cityName = payload.areaName;
        },
        [Types.SET_AREA_CUR_DISTRICT](state, payload: IAreaItem) {
            state.districtId = payload.id;
            state.districtName = payload.areaName;
        },
        
    },
    actions: {
        // 设置省市区列表
        async [Types.SET_AREA_LIST]({ commit }, params) {
            let result = await findAreaList(params);
            if (params.type === AREA_TYPE.PROVINCE_TYPE) {
                commit(Types.SET_AREA_PROVINCE_LIST, result.data);
            }else if (params.type === AREA_TYPE.CITY_TYPE) {
                commit(Types.SET_AREA_CITY_LIST, result.data);
            }else if (params.type === AREA_TYPE.DISTRICT_TYPE) {
                commit(Types.SET_AREA_DISTRICT_LIST, result.data);
            }
        }
    }
};
export default area;